import { Outlet, useLocation } from "react-router-dom";
import Navbar from "../staticView/globalComponents/Navbar";
import Footer from "../staticView/globalComponents/Footer";
import TopBar from "../staticView/globalComponents/TopBar";

function Layout() {
  const location = useLocation();

  // Add routes where Navbar should be hidden
  const hideNavbarRoutes = [
    "/dashboard/allocation/unallocated",
    "/dashboard/allocation/updates",
    "/dashboard/allocation/history",
  ];
  const isHistoryPage = location.pathname.toLowerCase() === "/dashboard/allocation/history";

  const shouldHideNavbar = hideNavbarRoutes.includes(location.pathname) || isHistoryPage;

  return (
    <div className="w-full">
      <div className="min-h-screen w-full flex flex-col items-center">
        {!isHistoryPage ? (
          <div className="sticky top-0 z-50 w-full">
            {shouldHideNavbar ? <TopBar /> : <Navbar />}
          </div>
        ) : null}

        <div className="flex w-full mx-auto overflow-y-hidden overflow-x-auto">
          <div className="flex flex-1 flex-col h-full">
            <main
              className={`flex-1 h-full overflow-y-auto overflow-x-auto ${
                isHistoryPage ? "" : "md:overflow-x-hidden"
              }`}
            >
              <Outlet />
            </main>
          </div>
        </div>
      </div>
      {!shouldHideNavbar && !isHistoryPage && <Footer />}
    </div>
  );
}

export default Layout;
